
function SecureManual() {    

    return (
            <div className='layer_overlay' style={{overflowY:'auto', overflowX:'none'}}>
                <div>
                <center>
                    <table border='0' cellPadding='0'>
                        <tr><td><img src="/images/page001_Title.png" /></td></tr>
                        <tr><td><img src="/images/page002_Contents.png" /></td></tr>
                        <tr><td><img src="/images/page003_all.png" /></td></tr>
                        <tr><td><img src="/images/page004.png" /></td></tr>
                        <tr><td><img src="/images/page005.png" /></td></tr>
                        <tr><td><img src="/images/page006.png" /></td></tr>
                        <tr><td><img src="/images/page007.png" /></td></tr>
                        <tr><td><img src="/images/page008.png" /></td></tr>
                        <tr><td><img src="/images/page009.png" /></td></tr>
                        <tr><td><img src="/images/page010.png" /></td></tr>
                        <tr><td><img src="/images/page011.png" /></td></tr>
                        <tr><td><img src="/images/page012.png" /></td></tr>
                        <tr><td><img src="/images/page013.png" /></td></tr>
                        <tr><td><img src="/images/page014.png" /></td></tr>
                        <tr><td><img src="/images/page015.png" /></td></tr>
                        <tr><td><img src="/images/page016.png" /></td></tr>
                        <tr><td><img src="/images/page017.png" /></td></tr>
                        <tr><td><img src="/images/page018.png" /></td></tr>
                        <tr><td><img src="/images/page019.png" /></td></tr>
                        <tr><td><img src="/images/page020.png" /></td></tr>
                        <tr><td><img src="/images/page021.png" /></td></tr>
                        <tr><td><img src="/images/page022.png" /></td></tr>
                        <tr><td><img src="/images/page023.png" /></td></tr>
                        <tr><td><img src="/images/page024.png" /></td></tr>
                        <tr><td><img src="/images/page025.png" /></td></tr>
                        <tr><td><img src="/images/page026.png" /></td></tr>
                        <tr><td><img src="/images/page027.png" /></td></tr>
                        <tr><td><img src="/images/page028.png" /></td></tr>
                        <tr><td><img src="/images/page029.png" /></td></tr>
                        <tr><td><img src="/images/page030.png" /></td></tr>
                        <tr><td><img src="/images/page031.png" /></td></tr>
                        <tr><td><img src="/images/page032.png" /></td></tr>
                        <tr><td><img src="/images/page033.png" /></td></tr>
                        <tr><td><img src="/images/page034.png" /></td></tr>
                        <tr><td><img src="/images/page035.png" /></td></tr>
                        <tr><td><img src="/images/page036.png" /></td></tr>
                        <tr><td><img src="/images/page037.png" /></td></tr>
                    </table>
                </center>
                </div>
            </div>
    );
}

export default SecureManual;